import {
  ButtonAlign,
  IAdvancedRichText,
  IBaseLayoutOptions,
  IGraphicWidget,
  IconType,
  WidgetType,
} from '@framework/engine';
import { ButtonType } from 'antd/es/button';

export interface IDownloadWidgetLayout extends IBaseLayoutOptions {
  iconType?: IconType;
  buttonType?: ButtonType;
  buttonAlign?: ButtonAlign;
}

export const WidgetDownloadType = 'download' as WidgetType.Download;

/**
 * Interfaccia Download Widget
 */
export interface IDownloadWidget extends IGraphicWidget {
  id: string;
  type: WidgetType.Download;
  label?: IAdvancedRichText;
  layout?: IDownloadWidgetLayout;
  filePath?: string;
}
